import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Creators as bseActions } from '../../../../../../../domain/useCases/bse/getFormBseUseCase';
import { Creators as bseActivateOrderActions } from '../../../../../../../domain/useCases/bse/activatePayOrderUseCase';
import { Creators as procedureStatusActions } from '../../../../../../../domain/useCases/procedures/getStudentProcedureStatus';
import constants from '../../../../constants';
import routes from '../../../../../../components/Routes/routingMap';
import RegisterBaseView from './RegisterBseView';
import FormIndexViewController from '../forms/index/FormIndexViewController';

const RegisterBseController = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const arrSteps = [...constants.arrStepsBSE];

  // states
  const [showModal, setShowModal] = React.useState(false);
  const [showForms, setShowForms] = React.useState(false);

  // to validate documents of FileUpload
  const [isValidDocuments, setIsValidDocuments] = React.useState(false);

  const procedure = useSelector(
    (state: any) => state.procedureInformation?.procedure
  );

  const { operationNumber: idRequest, isLoading: isLoadingRegister } =
    useSelector((state: any) => state.registerBse);

  const { isLoading: loadingFormBSE } = useSelector(
    (state: any) => state.getFormBse
  );
  const {
    isLoading: loadingActivatePayOrder,
    isSuccess: isSuccessActivatePay,
    data: operationNumberActivatePay
  } = useSelector((state: any) => state.activatePayOrder);

  const { isLoading: loadingProcessBSE } = useSelector(
    (state: any) => state.processBse
  );

  useEffect(() => {
    if (
      !loadingFormBSE &&
      !loadingProcessBSE &&
      !procedure &&
      !isLoadingRegister &&
      !idRequest
    ) {
      history.push('/tramites');
    }
  }, [loadingFormBSE, loadingProcessBSE, procedure]);

  const handlerCompleteForm = () => {
    setShowForms(true);
    window.scrollTo(0, 0);
  };

  const goTo = (path: string) => {
    history.push(path);
  };
  const handlerCloseModal = () => {
    if (isSuccessActivatePay) {
      goTo(routes.student.procedures.categories.scholarships.bse.progress);
    }
    setShowModal(false);
  };

  const redirect = () => {
    history.push(routes.student.payments.home);
  };
  const handlerActivatePayment = () => {
    dispatch(
      bseActivateOrderActions.activatePayOrder(
        procedure.currentRequestId,
        'UTP+Portal'
      )
    );
  };
  const handlerOkModal = () => {
    if (isSuccessActivatePay) {
      redirect();
    } else {
      handlerActivatePayment();
    }
  };

  const handlerStepAction = () => {
    setShowModal(true);
  };

  const handlerRedirect = () => {
    redirect();
  };

  const updateStatus = (operationNbr: any) => {
    dispatch(
      procedureStatusActions.getStudentProcedureStatus(
        1013,
        parseInt(operationNbr, 10)
      )
    );
  };

  useEffect(() => {
    dispatch(bseActions.getFormBse(idRequest || 0));
    dispatch(bseActivateOrderActions.activatePayOrderClear());
    dispatch(procedureStatusActions.getStudentProcedureStatusClear());
  }, []);

  useEffect(() => {
    if (procedure) {
      if (procedure.currentRequestId === 0) {
        // pendiente de validar errores y casuisticas
      } else {
        updateStatus(procedure.currentRequestId);
        history.push(
          routes.student.procedures.categories.scholarships.bse.progress
        );
      }
    }
  }, [procedure]);

  useEffect(() => {
    if (isSuccessActivatePay) {
      updateStatus(operationNumberActivatePay);
    }
  }, [isSuccessActivatePay]);

  const deleteUploadedFile = () => {};
  const sendDocuments = () => {};
  const downloadUploadedFile = () => {};

  if (showForms) {
    return (
      <FormIndexViewController
        handlerBack={() => {
          setShowForms(false);
          if (idRequest > 0) {
            updateStatus(idRequest);
            dispatch(bseActions.getFormBse(idRequest));
            goTo(
              routes.student.procedures.categories.scholarships.bse.progress
            );
          }
        }}
      />
    );
  }

  return (
    <RegisterBaseView
      loadingFormBSE={loadingFormBSE}
      loadingPayment={loadingActivatePayOrder}
      successActivatePay={isSuccessActivatePay}
      procedure={procedure}
      handlerCompleteForm={handlerCompleteForm}
      handlerNextStep={() => {}}
      formIsCompleted={undefined}
      formDocumentIsCompleted={undefined}
      showModal={showModal}
      handlerCloseModal={handlerCloseModal}
      handlerStepAction={handlerStepAction}
      handlerRedirect={handlerRedirect}
      handlerOkModal={handlerOkModal}
      handleSend={() => {}}
      loadingProcessBSE={loadingProcessBSE}
      stepStatus={arrSteps}
      dataValidate={{
        status: '',
        paymentActivated: isSuccessActivatePay,
        payed: false
      }}
      finalStateBse={{
        commentary: '',
        dateRequest: 0,
        dateFinalized: 0,
        discount: '',
        expirationDate: 0,
        isLastAttempt: false
      }}
      deleteUploadedFile={deleteUploadedFile}
      sendDocuments={sendDocuments}
      downloadUploadedFile={downloadUploadedFile}
      aditionalDocuments={[]}
      isValidDocuments={isValidDocuments}
      setIsValidDocuments={setIsValidDocuments}
      isLoadingUpdateFiles={false}
      onBack={() => {}}
    />
  );
};

export default RegisterBseController;
